import { render, staticRenderFns } from "./search-result.vue?vue&type=template&id=20dff0c0&scoped=true"
import script from "./search-result.vue?vue&type=script&lang=js"
export * from "./search-result.vue?vue&type=script&lang=js"
import style0 from "./search-result.vue?vue&type=style&index=0&id=20dff0c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dff0c0",
  null
  
)

export default component.exports